import { PickupForm, PickupFormData } from './PickupForm';
import { formValidation } from './schema';

export type { PickupFormData };
export { formValidation };
export default PickupForm;
